import { NgModule } from '@angular/core';
import { VaBadgeComponent } from './va-badge.component';

@NgModule({
  declarations: [VaBadgeComponent],
  exports: [VaBadgeComponent],
})
export class VaBadgeModule {}
